import { Vue, Component } from 'vue-property-decorator'
import { find, forOwn } from 'lodash'
import { CouponType, PromotionType } from '@constant/index'
import { toDemotion } from '@utils/index'
@Component({
  filters: {
    discounts: (item: any) => {
      const couponList = item.couponList || []
      const bestCoupon: any = couponList[0]
      const prodPromotionList = item.prodPromotionList || []
      const seckill = find(prodPromotionList, { type: PromotionType.seckill })
      const group = find(prodPromotionList, { type: PromotionType.group })
      let text = ''
      if (seckill || group) {
        // const single = group && group.groupType == 1 //单人团
        const multiple = group && group.groupType == 2 //多人团
        text = seckill ? '秒杀活动' : multiple ? `${group.groupLimitNum}人团` : `拼团活动`
      } else if (bestCoupon) {
        const { couponAmount, useAmountLimit } = bestCoupon
        const caInt = toDemotion(couponAmount)
        const ualInt = toDemotion(useAmountLimit)
        if (bestCoupon.couponType == CouponType.cash) {
          text = `${caInt}元现金券`
        } else if (bestCoupon.couponType == CouponType.fullReduction) {
          text = `满${ualInt}减${caInt}元券`
        }
      }
      return text
    },
    seekDiscounts: (item: any) => {
      return item.promotionName || item.couponName
    }
  }
})
export class DiscountsMixin extends Vue {
  seekCoupon(item: any) {
    const couponList = item.couponList
    return couponList && couponList[0]
  }

  seekPromotion(item: any) {
    const promotionMap = item.promotionList ? JSON.parse(item.promotionList) : {}
    const promotion: any = {}
    forOwn(promotionMap, (value:any,key: any) => {
      if (key == PromotionType.seckill) {
        promotion.seckill = value
      }
      if (key == PromotionType.group) {
        promotion.group = value
      }
      if (key == PromotionType.subtract) {
        promotion.subtract = value
      }
      if (key == PromotionType.present) {
        promotion.present = value
      }
    })
    return promotion
  }

  //标签 1营销标签 promotion1 接口约定只有一个  2普通标签 promotion2 最多4个
  seekCommodityPromotion(item: any, type: number) {
    const { promotion1 = [], promotion2 = [] } = JSON.parse(item.promotions || "{}")
    if (type === 1) {
      const [p = ''] = promotion1
      return p
    } else {
      return promotion2
    }
    return ''
  }
}
